export default "__VITE_PUBLIC_ASSET__a9c97d29__"